import { createContext, useContext, type FC, type ReactNode } from 'react'
import { type RecentStore } from 'widgets/RecentlySent'

export const RecentContext = createContext<RecentStore | null>(null)

export const useRecentContext = () => {
  const context = useContext(RecentContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with RecentContext')

  return context
}

type IProviderRecentProps = {
  value: RecentStore
  children: ReactNode
}

export const ProviderRecent: FC<IProviderRecentProps> = ({ value, children }) => {
  return <RecentContext.Provider value={value}>{children}</RecentContext.Provider>
}
